var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',_vm._b({attrs:{"height":"24","viewBox":"0 0 24 24","width":"24"}},'svg',_vm.$attrs,false),[_c('path',{staticClass:"c",attrs:{"d":"M8 6.82v10.36c0 .79.87 1.27 1.54.84l8.14-5.18c.62-.39.62-1.29 0-1.69L9.54 5.98C8.87 5.55 8 6.03 8 6.82z"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }